import { useState } from "react";
import { Option } from "./DropdownTypes";

const useDropdown = ({
  options,
  defaultSelectedOptions = [],
}: {
  options: Option[];
  defaultSelectedOptions?: Option[];
}) => {
  const [selectedOptions, setSelectedOptions] = useState<Option[]>(
    defaultSelectedOptions
  );

  const onSelected = (option: Option) => {
    if (
      selectedOptions.filter(({ value }) => option.value === value).length > 0
    ) {
      setSelectedOptions(
        selectedOptions.filter(({ value }) => option.value !== value)
      );
      return;
    }
    setSelectedOptions([option, ...selectedOptions]);
  };

  const selectedOptionValues = selectedOptions.map(({ value }) => value);

  const optionsWithSelectedItems = options.map((option) => ({
    ...option,
    selected:
      selectedOptions.filter(({ value }) => option.value === value).length > 0,
  }));

  return {
    onSelected,
    selectedOptions,
    optionsWithSelectedItems,
    selectedOptionValues,
  };
};

export default useDropdown;
